import type { Result } from '@carvana/merch-result';
import { axios, httpWithAuth } from '~/clients';
import { NBA_RECENT_VEHICLES_URL } from '~/constants/home';
import type { BffVehicle } from '~/contracts/home';

type RecentVehiclesRequest = {
  useAuth: boolean;
};

export default async function fetchRecentVehicles(
  { useAuth }: RecentVehiclesRequest,
  controller: AbortController
): Promise<Result<BffVehicle[]>> {
  const fetcher = useAuth ? httpWithAuth : axios;

  const { data } = await fetcher.get<Result<BffVehicle[]>>(
    NBA_RECENT_VEHICLES_URL,
    { signal: controller.signal }
  );

  return data;
}
